import { CommsCohort } from '@/features/comms/screens/CommsCohort';

/**
 * Standalone "Supabase Cohort" ops page (comms canary).
 *
 * Lets ops see and manage which workers are on the Supabase comms backend.
 * Talks only to the graphy admin REST API (`/api/admin/comms/allowlist`), so
 * unlike the Supabase Chat page it needs no Supabase client / provider.
 *
 * Ops-gated (TENANT_ADMIN / HELPDESK_ADMIN) at the route layer, mirroring the
 * Supabase Chat route.
 */
const SupabaseCohort = () => <CommsCohort />;

export default SupabaseCohort;
